import { Action, State } from './interfaces';

const startDate = new Date();
startDate.setDate(startDate.getDate() - 30);

export const initialFiltersState: State = {
  invoiceType: '',
  startDate,
  endDate: new Date(),
  supplier: ''
};

export const reducerFilters = (state: State, action: Action) => {
  switch (action.type) {
    case 'INVOICE_TYPE':
      return {
        ...state,
        invoiceType: action.invoiceType
      };
    case 'SUPPLIER':
      return {
        ...state,
        supplier: action.supplier
      };
    case 'START_DATE':
      return {
        ...state,
        startDate: action.startDate
      };
    case 'END_DATE':
      return {
        ...state,
        endDate: action.endDate
      };
    default:
      return state;
  }
};
